import type { AxiosInstance } from 'axios';
import type { CallEndpoint } from './contracts/endpoint';

/**
 * Gateway for interacting with the Calls API.
 */
export class CallsGateway {
  constructor(
    private readonly httpClient: AxiosInstance,
    private readonly baseUrl: string,
  ) {}

  /**
   * Retrieves all call endpoints and their current status.
   * @returns The list of call endpoints.
   */
  async getEndpoints(): Promise<CallEndpoint[]> {
    const { data } = await this.httpClient.get<CallEndpoint[]>(`${this.baseUrl}/api/v1/endpoints`);
    return data;
  }
}

export type { CallEndpoint, CallEndpointStatus } from './contracts/endpoint';
